import words from 'lodash/words'
import isString from 'lodash/isString'

export default roles => (isString(roles) ? words(roles, /(ROLE[A-Z|0-9|_]+)/g) : roles)
